import React from 'react';
import { useParams } from 'react-router-dom';

import { useGetContentQuery } from 'api';
import { Loaders } from 'components';
import { useNotify } from 'hooks';

import PostEdit from './PostEdit';

const PostContentLoader = () => {
  const { content_id } = useParams<{ content_id: string }>();
  const notify = useNotify();

  const { data, isLoading } = useGetContentQuery(
    { content_id },
    {
      onError: notify.queryError,
    }
  );

  if (isLoading) {
    return <Loaders.Standard />;
  }

  return <PostEdit content={data.getContent} />;
};

export default PostContentLoader;
